import React, { useState } from "react";
import { Layout, Space, Select } from "antd";
import { useSelect } from "@refinedev/antd";
import { tenantService } from "../services/tenantService";
import type { SelectProps } from "antd";
import { TenantTag } from "./TenantTag";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import EnvironmentInfo from "../components/EnvironmentInfo";

const { Header: AntHeader } = Layout;

export const Header: React.FC = () => {
  const [, setUpdateTrigger] = useState({});
  const [isSelectOpen, setIsSelectOpen] = useState(false);

  const { selectProps: tenantSelectProps } = useSelect({
    resource: "tenants",
    optionLabel: "name",
    optionValue: "id",
    meta: {
      fields: ["id", "name"],
    },
  });

  const modifiedOptions = tenantSelectProps.options?.map((option: any) => ({
    ...option,
    label: tenantService.getTenantDisplayInfo(option.value, option.label).longName,
  }));

  const handleTenantChange: SelectProps["onChange"] = (value, option) => {
    if (typeof value === "string" && option && "label" in option) {
      tenantService.setCurrentTenant({
        id: value,
        name: option.label as string,
      });
      setUpdateTrigger({});
    }
  };

  return (
    <AntHeader
      style={{
        background: "#fff",
        padding: "0 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "80px",
        borderBottom: "1px solid #F0F0F0",
        position: "sticky",
        top: 0,
        width: "100%",
        zIndex: 1000,
      }}
    >
      <div className="logo" style={{ height: "48px", display: "flex", alignItems: "center" }}>
        <img
          src="/assets/logomark.svg"
          alt="Homebase Logo"
          style={{ height: "100%" }}
          onDoubleClick={EnvironmentInfo.show}
        />
      </div>

      <Space size={0} style={{ display: "flex", alignItems: "center" }}>
        <TenantTag useShortName />
        <Select
          {...tenantSelectProps}
          showSearch={false}
          options={modifiedOptions}
          value={tenantService.getCurrentTenant().id}
          style={{ width: 240, height: "40px" }}
          onChange={handleTenantChange}
          onDropdownVisibleChange={(open) => setIsSelectOpen(open)}
          suffixIcon={isSelectOpen ? <UpOutlined /> : <DownOutlined />}
        />
      </Space>
    </AntHeader>
  );
};
